import { Skeleton, styled } from '@mui/material';
import React from 'react';
import Column from 'src/frontend-common/components/Column';
import Row from 'src/frontend-common/components/Row';

const ContentRow = styled(Row)(() => ({
  height: 83,
  borderBottom: '1px solid #E5E5E5',
  '&>div': {
    padding: 16,
    alignItems: 'center',
    justifyContent: 'center',
    width: '10%',
    '&:first-of-type': {
      justifyContent: 'flex-start',
      width: '90%',
    },
  },
}));

const TableSkeleton: React.FC = () => (
  <Column>
    <Skeleton variant="rectangular" width="100%" height={38} />
    <>
      {[...Array(6)].map((_, i) => (
        <ContentRow key={`RiskChartSkeleton-${i}`}>
          <Row>
            <Skeleton variant="rounded" width={35} height={28} style={{ marginRight: 10 }} />
            <Skeleton variant="text" width={Math.floor(Math.random() * 70) + 30} height={26} />
          </Row>
          <Row>
            <Skeleton variant="text" width={30} height={26} />
          </Row>
        </ContentRow>
      ))}
    </>
    <Row
      style={{
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: 16,
        height: 64,
      }}
    >
      <Skeleton variant="text" width={61} height={26} style={{ marginRight: 25 }} />
      <Row style={{ alignItems: 'center' }}>
        <Skeleton variant="rectangular" width={18} height={18} style={{ marginRight: 20 }} />
        <Skeleton variant="rectangular" width={18} height={18} />
      </Row>
    </Row>
  </Column>
);

export default TableSkeleton;
